var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoconnectmgihb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 572.102,
    height: 188,
    viewBox: "0 0 572.102 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "conwhite",
    transform: "translate(-857 -1980)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HBapprove",
    transform: "translate(1215.338 1844.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_H_B_White",
    "data-name": "Logo_H&B_White",
    transform: "translate(-332.897 141.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M135.38,428.388h-3.442v3.7h-4.149V436.8H14.151v-4.673H8.863v-3.743H5.8V425.5H8.824v-4.62h5.288V415.6H127.723v5.209H131.9v4.633h3.495C135.38,426.438,135.38,427.406,135.38,428.388Z",
    transform: "translate(0 -338.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M661.041,26c.89.183,1.78.34,2.67.537a22.4,22.4,0,0,1,9.882,5.013,23.624,23.624,0,0,1,6.806,9.921A24.617,24.617,0,0,1,681.774,48a24.14,24.14,0,0,1-1.832,11.531,23.707,23.707,0,0,1-4.2,6.61,23.026,23.026,0,0,1-8.927,6.243,16.921,16.921,0,0,1-6.034,1.4c-6.191.052-12.382.013-18.586.013-.092,0-.183-.026-.34-.039-.013-.249-.052-.484-.052-.733V26.694c0-.236.039-.458.052-.694Z",
    transform: "translate(-552.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M393.938,26c-.681.694-1.322,1.414-2.029,2.081a1.424,1.424,0,0,0-.471,1.152q.02,21.754.013,43.495v.942H365.521c-.013-.2-.039-.393-.039-.589,0-5.668-.013-11.348,0-17.016q.039-13.056.157-26.1a2.845,2.845,0,0,0-.89-2.186c-.576-.576-1.1-1.178-1.649-1.767Q378.512,25.993,393.938,26Z",
    transform: "translate(-310.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M642.9,606.8h16.6a22.556,22.556,0,0,1,14.241,4.882,23.5,23.5,0,0,1,7.67,10.537,24.25,24.25,0,0,1,1.531,9.817,23.9,23.9,0,0,1-5.5,14.254,22.737,22.737,0,0,1-14.424,8.246,13.711,13.711,0,0,1-2.2.17q-8.521.02-17.029.013h-.89Z",
    transform: "translate(-553.71 -504.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M53.756,607H79.711c.013.3.039.563.039.838v40.288c0,1.086-.079,2.173-.052,3.259a1.438,1.438,0,0,0,.34.838c.654.759,1.361,1.492,2.133,2.33H51.531l-.131-.131c.615-.576,1.217-1.165,1.859-1.715a1.512,1.512,0,0,0,.524-1.27q-.02-21.754-.013-43.495C53.756,607.641,53.756,607.34,53.756,607Z",
    transform: "translate(-39.631 -504.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M365.613,607.9h25.968v.746q0,14.195,0,28.4c-.013,4.764-.039,9.529-.144,14.293a3.145,3.145,0,0,0,1.073,2.526c.5.484.942,1.008,1.492,1.61H363.218c-.039-.052-.079-.092-.118-.144.667-.628,1.322-1.27,2-1.872a1.461,1.461,0,0,0,.524-1.27q-.02-21.675-.013-43.337Z",
    transform: "translate(-310.533 -505.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M80.872,75.818H54.891v-.89q.079-21.6.157-43.18a2.216,2.216,0,0,0-.72-1.7c-.563-.563-1.086-1.165-1.728-1.846H83.424c-.72.72-1.335,1.4-2,2a1.613,1.613,0,0,0-.563,1.322q.02,21.675.013,43.351Z",
    transform: "translate(-40.674 -1.912)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1322",
    "data-name": "Trac\\xE9 1322",
    d: "M44.252-2.256Q38.162.9,29.1.9,17.37.9,10.3-6.5T3.233-25.942q0-12.934,7.952-20.9t20.1-7.971A32.934,32.934,0,0,1,44.252-52.6v8.873a23.147,23.147,0,0,0-12.031-3.233q-8.76,0-14.193,5.6T12.6-26.394q0,8.911,5.076,14.193T31.018-6.918a23.9,23.9,0,0,0,13.234-3.609ZM75.722.9Q64.066.9,57.054-6.655T50.042-26.318q0-13.009,7.144-20.754t19.4-7.745q11.354,0,18.291,7.52t6.937,19.664q0,13.2-7.106,20.867T75.722.9Zm.414-47.862a15,15,0,0,0-12.05,5.527q-4.643,5.527-4.643,14.55,0,8.986,4.512,14.475A14.548,14.548,0,0,0,75.759-6.918q7.745,0,12.219-5.226T92.453-26.77q0-9.663-4.343-14.926T76.135-46.959ZM157.421,0h-9.775L121.892-39.628a17.571,17.571,0,0,1-1.617-3.121h-.226a55.506,55.506,0,0,1,.3,7.407V0H111.7V-53.915h10.415l24.89,38.688q1.579,2.406,2.03,3.309h.15a47.906,47.906,0,0,1-.376-7.256v-34.74h8.61Zm59.066,0h-9.775L180.958-39.628a17.571,17.571,0,0,1-1.617-3.121h-.226a55.508,55.508,0,0,1,.3,7.407V0h-8.647V-53.915h10.415l24.89,38.688q1.579,2.406,2.03,3.309h.15a47.906,47.906,0,0,1-.376-7.256v-34.74h8.61ZM260.1,0H229.834V-53.915H258.9v7.595H238.783v15.265h18.536V-23.5H238.783V-7.557H260.1Zm47.185-2.256Q301.195.9,292.134.9,280.4.9,273.335-6.5t-7.068-19.438q0-12.934,7.952-20.9t20.1-7.971A32.934,32.934,0,0,1,307.286-52.6v8.873a23.147,23.147,0,0,0-12.031-3.233q-8.76,0-14.193,5.6t-5.433,14.964q0,8.911,5.076,14.193t13.347,5.282a23.9,23.9,0,0,0,13.234-3.609ZM352.1-46.32h-15.49V0h-8.948V-46.32H312.211v-7.595H352.1Z",
    transform: "translate(-138.338 256.925)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    transform: "translate(857 1980)",
    fill: "none",
    stroke: "none",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 94,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 93.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoconnectmgihb);
export default __webpack_public_path__ + "static/media/logoconnectmgihb.34f92b91a2cf683a538dbc5faae2124a.svg";
export { ForwardRef as ReactComponent };